import * as z from "zod/v4";

export const duplicateSignupForm = {
  name: "duplicateSignupForm" as const,
  input: z.object({ formId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
